export const environment = {
    environmentLabel: 'dev',
    production: false,
    baseUrl: 'https://api.primeaccessinc.dev/api/',
    stripeKey: 'pk_test_51Q5fiNP57PUi0inZzTwY2OOuDAJeQLPuSbq5qrZylR8lDqYoeTFP7JeI2VPLJ1c2uwRKAltafYGLqOu9vljH0S1600M1wYVFER',
    SocketURL: '',
    merchantId: "BCR2DN4TZKCPLGDA",
    merchantName: "Prime Access Inc",
    googeMapAPI: 'AIzaSyCuRqPD-V6St_Ih6R22D9ZF8abym2ROtMg'
};
